// extracted by mini-css-extract-plugin
export default {"root":"KasaPin_root__S+DMT","selected":"KasaPin_selected__yuNJc"};